// extracted by mini-css-extract-plugin
export default {"ticketNamePrice":"t+MT5","description":"sX5T8"};